'use strict'

import qs from 'qs'
import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'
import api from "../utils/api.js";

const isEmpty = obj=>obj === null || obj === undefined || obj === '';

let W = window, Promise = W.Promise, errorMsg = '', warnMsg = '', successMsg = '', iStop = false;

const msgError = W.msgError = function (_this, msg, time) {
  typeof _this !== 'object' && ( time = msg, msg = _this, _this = App );
  if( msg === errorMsg || msg.trim() === '' ) return false;
  (v=>errorMsg='').sleep(200);
  return _this.$message({
    message: errorMsg = msg,
    type: "error",
    showClose: true,
    duration: time||3000
  });
};
const msgSuccess = W.msgSuccess = function (_this, msg, time) {
  typeof _this !== 'object' && ( time = msg, msg = _this, _this = App );
  if( msg === successMsg || msg.trim() === '' ) return false;
  (v=>successMsg='').sleep(200);
  return _this.$message({
    message: msg,
    type: "success",
    showClose: true,
    duration: time || 1200
  });
};
const msgWarn = W.msgWarn = function (_this, msg, time) {
  typeof _this !== 'object' && ( time = msg, msg = _this, _this = App );
  if( msg === warnMsg || msg.trim() === '' ) return false;
  (v=>warnMsg='').sleep(200);
  return _this.$message({
    message: msg,
    type: "warning",
    showClose: true,
    duration: time || 2200
  });
};

const alertSuccess = W.alertSuccess = (_this, msg, time, title)=>{
  typeof _this !== 'object' && ( [ _this, msg, time, title ] = [ App, _this, msg, time] );
  typeof time === 'string' && ( [time,title] = [title,time] );
  return alertSuccess.vue = _this.$notify({
    title: title||"提示信息",
    dangerouslyUseHTMLString: true,
    message: msg,
    type: "success",
    duration: time > -1 ? time : 1500,
    offset: 35
  });
};
alertSuccess.reset = function() {
  alertSuccess.vue && alertSuccess.vue.close();
  return arguments.length > 0 ? alertSuccess.apply(null,arguments) : alertSuccess.vue || false;
};

const Pos = {
  __proto__: null,
  'top-right': true,
  'bottom-right': true,
  'top-left': true,
  'bottom-left': true,
  'msg': '',
};
const alertError = W.alertError = (_this, msg, time, title)=>{
  typeof _this !== 'object' && ( [ _this, msg, time, title ] = [ App, _this, msg, time] );
  typeof time === 'string' && ( [time,title] = [title,time] );
  if( !msg ) return false;
  if( Pos.msg.trim() == ( Pos.msg = msg = msg.trim() ) ) return false;
  sleep.clear(200.01352649562,v=>Pos.msg='');
  return alertError.vue = _this.$notify({
    title: !Pos[title] && title || "失败信息",
    dangerouslyUseHTMLString: true,
    message: msg,
    type: "error",
    duration: time || 0,
    position: !Pos[title] ? 'top-right' : title,
    offset: 35
  });
};
alertError.reset = function() {
  alertError.vue && alertError.vue.close();
  return arguments.length > 0 ? alertError.apply(null,arguments) : alertError.vue || false;
};

const alertWarn = W.alertWarn = (_this, msg, time, title)=>{
  typeof _this !== 'object' && ( [ _this, msg, time, title ] = [ App, _this, msg, time] );
  typeof time === 'string' && ( [time,title] = [title,time] );
  return alertWarn.vue = _this.$notify({
    title: !Pos[title] && title || "警告提醒",
    dangerouslyUseHTMLString: true,
    message: msg,
    type: "warning",
    duration: time > -1 ? time : 3000,
    position: !Pos[title] ? 'top-right' : title,
    offset: 35
  });
};
alertWarn.reset = function(){
  alertWarn.vue && alertWarn.vue.close();
  return arguments.length > 0 ? alertWarn.apply(null,arguments) : alertWarn;
};

let isExiting = false;
function checkStatus(response) {
  // 如果myhttp状态码正常，则直接返回数据
  // console.log(response,iStop);
  // if( iStop ) return { data: { msg: '', result: 'error' }, exit: true };
  if( !response ) {
    // msgError(this,'您的Session可能已过期，请刷新重试或者重新登陆！');
    // iStop = true;
    /*switch( confirm('您的Session可能已过期，要为您重新登陆吗?') ){
      case true: View.navBar ? View.navBar.outLogin(i=>iStop=false) : W.location.href = "/login"; break;
      default: msgError(App,'您的Session可能已过期，请刷新重试或者重新登陆！'); (i=>iStop=false).sleep(400);
    };*/
    return { data: { msg: '请求出错！', result: 'error' }, exit: true };
  };
  if (response && (response.status === 200 || response.status === 304)) {
    if (response.data.code === 403) {
      msgError('用户无权限！');
    } else if (response.data.code === 702) {
      msgError('Session过期，请重新登陆！');
    };
    response.isuccess = response.data.result === 'success' ? true : 0;
    if( isExiting !== true && ( response.data.msg || '' ).includes( '没有登陆' ) ) {
      isExiting = true;
      confirm('您的登录已经失效，请前去登录！') && ( 
        App.Gorootpage()
        // W.location.reload()
      );
      sleep.clear(250.16349712,v=>isExiting=false);
    };
    return response;
    // 如果不需要除了data之外的数据，可以直接 return response.data
  };
  return App.$loading().close(), response;
  /* else if (response && (response.status === 401)) {
    // msgError('您没有权限！');
    App.$loading().close();
    return response;
  } else if (response && (response.status === 400)) {
    // msgError('请求参数错误！');
    App.$loading().close();
    return response;
  } else if (response && (response.status === 500)) {
    // msgError('网络请求出错, 请检查！');
    App.$loading().close();
    return response;
  } else  if (response && (response.status === 404)){
    // msgError('其他错误, 请检查！');
    App.$loading().close();
    return response;
  };*/
};

function copy(value) {
  return JSON.parse(JSON.stringify(value));
};

//判断数组是否相等
function isArrayEqual(value1 = [], value2 = []) {
  let hash = JSON.parse(JSON.stringify(value2));
  if (value1.length === value2.length) {
    for (let i = 0; i < value1.length; i++) {
      const index = hash.indexOf(value1[i]);
      if (index > -1) {
        hash.splice(index, 1);
      } else {
        return false;
      }
    }
    return true;
  }
  return false;
};

//数组去重
function unique(arr) {
  return Array.from(new Set(arr))
};

function replaceSpace(str) {
  return str.split(" ").join("%");
};

function checkCode(res) {
  // if( iStop ) return { data: { msg: '', result: 'error' }, exit: true };
  if( !res ) {
    // msgError(this,'您的Session可能已过期，请刷新重试或者重新登陆！');
    // iStop = true;
    /*switch( confirm('您的Session可能已过期，要为您重新登陆吗?') ){
      case true: View.navBar ? View.navBar.outLogin(i=>iStop=false) : W.location.href = "/login"; break;
      default: msgError(App,'您的Session可能已过期，请刷新重试或者重新登陆！'); (i=>iStop=false).sleep(400);
    };*/
    // msgError(App,'网络错误！');
    res = { data: { msg: '网络错误！', result: 'error' }, exit: true };
  }else if (res.status === -404 || res.status === 404) {
    // Message({
    //   message: '其他错误, 请检查！',
    //   type: 'error',
    // });
    // App.$loading().close();
    res.data = { msg: '其他错误, 请检查！' };
  };
  // res.data = res.data || { __proto__: null };
  return res;
};

/*const tdMask = (event)=>{
  let sleeper, target = event.target, paths = [target];
  while ( target.nodeName !== 'TD' && (target=target.parentNode) ) {
    paths[paths.length++] = target;
  };
  // console.warn(paths);
  (event.path||paths).find((v,s)=>{
    return v.nodeName === 'TD' && !v.classList.contains('el-table-column--selection') && !v.classList.contains('available') && (
      ( v.__mask__ || ( tdMask.el ? v.appendChild(tdMask.el.cloneNode()) : ( v.insertAdjacentHTML('beforeEnd','<div z-mask td-mask></div>'), tdMask.el = v.lastElementChild.cloneNode() ), v.__mask__ = v.lastElementChild ) ).style.with({ opacity: 1, display: '' }),
      sleeper = (e =>{
        v.__mask__.style.opacity = 0;
        ( e=>v.__mask__.style.display = 'none' ).sleep(30);
      } ).waitSleep(200),
      true
    );
  });
  // console.warn(sleeper);
  return sleeper;
};
tdMask.el = null, tdMask.id = 0, tdMask.sleeper = { __proto__: null }, tdMask.isleep = { __proto__: null };
document.addEventListener('click',e=>{
  const sleeper = tdMask(e);
  if( !sleeper ) return;
  const id = tdMask.id;
  // console.error(e.target);
  (v=>{
    // console.error(id,tdMask.id);
    id !== ( v = tdMask.id )
    ? tdMask.sleeper[v] !== ''
      ? tdMask.sleeper[v] = sleeper
      : sleeper(delete tdMask.sleeper[v],setTimeout(v=>forObj(tdMask.sleeper,(v,k)=>v==='' && delete tdMask.sleeper[k]),200))
    : sleeper();
  }).sleep(0);
},true);*/


export {
  isEmpty,
  msgError,
  msgSuccess,
  msgWarn,
  openLoading,
  closeLoading,
  isArrayEqual,
  unique,
  replaceSpace
};

let De = W.Date, Reg = /(currentPage\w*=)([2-9]|[1-9][0-9])/, Rfn = (a,b)=>b+1, myhttp;
const requireTipreg = /(删|移)除/, noop = ()=>{};

// console.error($Menus);
let $Menus = W.$Menus, Apis = $Menus.Apis, Apisurl = $Menus.Apisurl, Menuspath, $Newrouter;
// console.error(Menuspath, Apis);
const getOwn = A.getOwn, hideProperty = A.hideProperty, document = W.document, $typeOf = typeOf, $return = Return, ifSet = A.ifSet;
/*const Watchapi = { __proto__: null, $watchid: 0 };
hideProperty( Watchapi, '$watchid' );
( Vue.prototype.$watchapi = function(api,call){
  if( typeof api === 'function' ) call = api, api = null;
  else if( typeof call !== 'function' ) return ()=>{};

  let apist, id;
  if( api !== null ) {
    const meta = this.$route.meta;
    const metawatchapi = meta.$watchapi || hideProperty( meta, '$watchapi', {__proto__:null} );

    ifSet( Watchapi, api, api = meta.fpath + '::' + api );
    if( meta.refresh ) {
      for( id in apist = metawatchapi[ api ] ) delete apist[ id ];
      // console.error( apist, api, 123456789 );
    };
    apist = metawatchapi[ api ] = Watchapi[ api ] || ( Watchapi[ api ] = { __proto__: null } );
  };

  id = call.$watchid = ++Watchapi.$watchid;
  ( apist||Watchapi )[ id ] = call;

  const unwatch = call.unwatch = ( function(id){ delete this[id]; } ).bind(apist||Watchapi,id);
  ( ( call.this = this ).$destroyed||this.$options.destroyed).push( unwatch );
  // console.error( this._hookstate, this._isMounted, this.$route.meta.refresh );
  return unwatch;
} ).Watchapi = Watchapi;*/

const notifyApiList = $.notifyApiList = { __proto__: null };
Vue.prototype.$watchapi = function(api,call){ // page::api

  const apis = Apis[ api ];
  // console.error(api);
  // if( !apis ) return noop;

  let page = this.$host.$$path, pageApi = page + "::" + api;
  // console.error(page, api, pageApi);
  
  const ifSet = notifyApiList[ api ] || ( notifyApiList[ api ] = { __proto__: null } );
  
  ifSet[ pageApi ] && ifSet[ pageApi ] !== this && document.contains( ifSet[ pageApi ].$el ) && ( pageApi += '2' );

  // console.error(pageApi, ifSet);
  
  ifSet[ pageApi ] = ( notifyApiList[ pageApi ] = call.bind(this) ).this = this;

  // ifSet( notifyApiList, api, pageApi );
  // console.error(pageApi);
  return function() {
    delete notifyApiList[pageApi];
    delete ifSet[pageApi];
    for( let key in ifSet ) return;
    return delete notifyApiList[api];
  };
};

const notifyApi = $.notifyApi = (api,state,params,nextick)=>{
  var pageApi, call, res, $id$ = false;
  if( params.$id$ ) {
    // if( window.x ) return console.error(state, api, notifyApiList, $id$, params);
    $id$ = notifyApiList[ params.$id$ ];
    if( !$id$ ) {
      if( state === 1 ) {
        // console.error(nextick,state,notifyApiList);
        nextick === 2 ? params.$id$ = null : nextick = nextick || 0;
        sleep(0,()=>notifyApi(api,state,params,++nextick));
      };
      return;
    };
  };
  // console.error(state, api, notifyApiList[api], $id$);
  for( pageApi in $id$ || notifyApiList[ api ] ) {
    // console.error(api,pageApi);
    // if( $id$ !== '' && !pageApi.endsWith($id$) ) continue;
    if( ! ( call = notifyApiList[pageApi] ) ) continue;
    res = call(state);
    if( state === 0 ) continue;
    if( !document.contains( call.this.$el ) ) {
      delete notifyApiList[pageApi];
      // continue;
    };
  };
  return res;
};

const noopres = { __proto__: null };
Vue.prototype.$post = function(url,params,loading){
  console.error([this,url,Apisurl[url]]);
  // return window.a = new Promise(suc=>sleep(700,()=>suc({data:JSON.parse(A.local('tmp')),isuccess:true},notifyApi(Apisurl[url],1))));
  if( this.object2[ url ] ) return; // console.error(url,this);
  this.object2[ url ] = true;
  // console.error([ url, params ]);
  let isuc, ires = false, promise = new Promise(suc=>isuc=suc);
  myhttp
  .post(url,params,loading,this)
  .then(RES=>{
    // console.warn(5555555555555, RES);
    if(!RES) {
      console.error('请求出错了哦,请检查！',url);
      return alertError('请求出错了哦,请检查！');
    };
    if ( RES.isuccess !== true ) {
      if( promise.isilent !== true ) {
        // console.error(RES);
        if( RES.status === 401 ) {
          alertError( '您的登录已经失效，需要重新登录哦！', 5000 );
          return App.Gorootpage();
        };
        let msg = RES.status === 403 ? '您没有该权限！' : RES.msg || (RES.data||0).msg || "载入出现了点问题哦,请刷新浏览器！";
        // console.error(RES);
        alertError( msg, 10000 );
      };
    };
    ires = RES;
  })
  .finally(()=>{
    // console.error(url,this.object2);
    this.object2[ url ] = false;
    isuc(ires||noopres);
  });
  return promise;
};

const NaN = W.NaN; let iApp = false;

axios.interceptors.request.use(config=>config,error=>Promise.reject(error));
axios.interceptors.response.use(response=>response,error=>Promise.resolve(error.response));
axios.defaults.withCredentials = true;
// console.error([axios]);
export default myhttp = {
  post: async(url, params, loading=NaN, self)=>{
    let apiName, method = 'post';
    const Newrouter = $Newrouter || ( $Newrouter = W.$Newrouter ), thisRoute = Newrouter.currentRoute.meta;
    // console.error(url, Apisurl[url]);
    if(url[0] === '?') method = 'get', url = url.slice(1);
    // console.error([ url, params ]);
    if( url[0] !== '/' ) {
      const menu = ( Menuspath || ( Menuspath = $Menus.Englishpaths ) || 0 ) [ thisRoute.fpath ] || 0;
      // if( !( url = Apis[ url ]  ) || !( url = url[0] ) ) return { msg: "请求地址错误!", ierror: true };
      url = ( menu.api || 0 )[ apiName = url ];
      if( !url ) return 
	  console.log(url)
	  // { msg: "请求地址错误!", ierror: true };
      loading !== loading && ( loading = url.$tip || '正在请求...' );
      url = url[0];
    }else {
      loading !== loading && ( loading = '正在请求...' );
      apiName = Apisurl[url];
    };

    const Appload = W.Appload;
    let now = De.now(), RES, initParams = params, index, sobj = 0, initloading = loading;//, id = ++tdMask.id;
    thisRoute.refresh && ( loading = false );
    apiName && ( RES = notifyApi( apiName, 0, initParams ) ) === false && ( loading = false );
    // console.error(loading, W.Appload);
    ( typeof loading === 'string' && Appload || Appload === false )
    && ( RES = self._hookstate ) !== 'deactivated' && RES !== 'created' ? $Loading(loading) : '';
    // console.error( $Newrouter.currentRoute, W.w._hookstate, 99999 );

    RES = $typeOf( params );
    if( RES !== 'string' && RES !== 'FormData' ) {
      // console.error(params);
      params = $return( params, (a,v,k)=>{
        if( typeof v !== 'function' && k[0] !== '$' )
          a[k] = typeof v === 'object' && v !== null && v.length > -1 ? v + '' : v;
      }, { __proto__: null } );
      try {
        params = qs.stringify(params);
      }catch(e){
        params = '';
      };
    };

    return RES = axios({
      method: method, // 'post',
      baseURL: api.baseUrl_online, //线上
      url: url.trimRight(),
      withCredentials: true,
      data: params,
      timeout: 900000,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        'token': A.local('$Usertoken'),
        'projectId': +A.local('$projectId'),
        // "Set-Cookie": `httpOnly; Secure; SameSite = None`,
        // res.setHeader('Set-Cookie',`name={"loginname":"${userName}"}; httpOnly; Secure; SameSite = None`);
      }
    })
    .then( async (response, p) => {
      // await sleep( 1000 );
      ( response = checkStatus(response) ).delay = De.now() - now;
      // console.error(RES,params);
      if( response.isuccess ) {
        requireTipreg.test( p = response.data.msg || response.msg || '' ) && alertSuccess( p, 500 );
        if( ( p = response.data.data ) && p.length === 0 && ( p = params.replace(Reg,Rfn) ) !== params ) {
          console.log('::页数过多,重置currentPage为1::',p);
          response = await myhttp.post(url,p,loading);
          console.log('::重新响应::',response);
        };
      };/*else if( RES.isilent !== true ) {
        ( p = response.data.msg || response.msg ) && alertError( p, 10000 );
      };*/
      response.ierror = !response.isuccess;
      // url === '/user/updateState' && await sleep(4000);
      // console.error( url,'名字::', RES );
      // await sleep(4000);
      return RES = response;
    })
    .catch(
      (response) => {
        ( response = checkCode(response) ).delay = De.now() - now;
        return RES = response;
      }
    )
    .finally(e=>{
      RES.params = initParams;
      console.log( url + ' => ' + apiName, RES );
      /*if( window.x ) {
        $Loaded.sleep(RES.delay < 100 ? 200 : 100);
        return console.error(notifyApiList), RES;
      };*/
      apiName && notifyApi( apiName, 1, initParams );
      if( Appload !== false && iApp ) {
        $Loaded.sleep(RES.delay < 100 ? 200 : 100);
      } else {
        $Loading('正在载入');
        sleep(350.0341).then(v=>$Loaded(iApp = true));
      };
      return RES;
    });
    // RES.myBind('isilent',v=>alert('message?: DOMString'));
    // return RES;
  },

  storage: async (file)=>{
    // console.error(file);
    // return 'www.baidu.com';
    if( file + '' !== '[object File]' ) return '';
    var form = new FormData();
    form.append("file", file);
    form.append("loginName", localStorage.getItem("loginName"));
    const res = await myhttp.postFile1($Api.fileUpLoadEditing,form);
    // console.error(res);
    if(res.data.success === true || res.data.result === 'success' || res.data.result === 'ok'){
        return onlinePhoto + res.data.fileAddress;
    } else {
        msgError(res.data.msg);
        return '';
    };
  },

  postFile(url, params, proc) {
    const now = De.now();
    return axios({
      method: 'post',
      baseURL: uploadUrl,
      url,
      data: params,
      timeout: 900000,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      onUploadProgress: typeof proc === 'function' && function(progressEvent){ //原生获取上传进度的事件
          if(progressEvent.lengthComputable){
              //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
              //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
              proc(progressEvent);
          }
      },
    }).then(
      (response) => {
        ( response = checkStatus(response) ).delay = De.now() - now;
        return response;
      })
      .catch(
        (response) => {
          ( response = checkCode(response) ).delay = De.now() - now;
          return response;
        }
      )
  },
  postFileUsers(url, params) {
    return axios({
        method: 'post',
        baseURL: api.baseUrl_online,
        url,
        data: params,
        timeout: 120000,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            'token': A.local('$Usertoken'),
            'projectId': +A.local('$projectId'),
        }
    }).then(
        (response) => {
            return checkStatus(response)
        })
        .catch(
            (res) => {
                return checkCode(res)
            }
        )
},

  downloadFile(url, name) { //下载
    if (!url) {
      return;
    };
    let link = De.link || ( De.link = document.createElement('a') );
    link.style.display = 'none';
    link.href = url;
    link.onload = function (e) {
      document.body.removeChild(link);
    };
    link.setAttribute('download', name||'');
    document.body.appendChild(link);
    link.click();
  },

  downloadPhone(myUrl, name) {
    if (!myUrl) {
      return
    }
    let url = W.URL.createObjectURL(new Blob([myUrl]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  },


};



// WEBPACK FOOTER //
// ./src/utils/myhttp.js